import React from 'react';
import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`;

const StyledComponent = styled.div`
  width: var(--loader-size, 100%);
  height: var(--loader-size, 100%);
  border-top: var(--loader-border-size, 4px) var(--loader-border-style, solid)
    currentColor;
  border-right: var(--loader-border-size, 4px) var(--loader-border-style, solid)
    transparent;
  border-radius: 50%;
  animation: var(--loader-animation-time, 1s) ${spin} linear infinite;
`;

const LineMovingRoundLoader = () => (
  <StyledComponent className={`line-moving-round`} />
);

export default LineMovingRoundLoader;
